import { render } from "./PdfAnlagenschemaTemplate.vue?vue&type=template&id=94b0dcc2&scoped=true&ts=true"
import script from "./PdfAnlagenschemaTemplate.vue?vue&type=script&lang=ts"
export * from "./PdfAnlagenschemaTemplate.vue?vue&type=script&lang=ts"

import "./PdfAnlagenschemaTemplate.vue?vue&type=style&index=0&id=94b0dcc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94b0dcc2"]])

export default __exports__